<template>
  <div>
    <i-container class="_margin-bottom-1-2">
      <i-pagination size="sm" id="pagination" v-model="currentPage" :items=totalItems :items-per-page="itemsPerPage"
                    @change="paginationChanged"></i-pagination>
    </i-container>
    <i-container>
      <i-table striped responsive>
        <thead>
        <tr>
          <td>COSPAR</td>
          <td>Period [s]</td>
          <td>Date</td>
          <td>Data</td>
          <td>Light Curve</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, index) in databaseSlice">
          <td class="_align-middle">
            <i-tooltip variant="light" placement="right">
              <span class="dotted-underline">{{row["object-id"]}}</span>
              <template slot="body">{{row["object-name"]}}</template>
            </i-tooltip>
          </td>
          <td class="_align-middle">{{row["period"]}}</td>
          <td class="_align-middle _width-25">{{row["date"]}}</td>
          <td class="_align-middle">
            <i-button outline variant="secondary" @click="showModal(row)">Details</i-button>
          </td>
          <td class="_display-xs-none _display-sm-none _display-md-table-cell _height-10 _width-15 _margin-right-1">
            <i-tooltip :arrow=false trigger="click" placement="left" variant="light"
                       :popperOptions="{positionFixed: true}">
              <img class="lazyload image -thumbnail _width-50" alt="Light curve thumbnail"
                   v-bind:src="require('./../assets/raw_data/images/'+row['lc-file'])"/>
              <template slot="body">
                <div class="_display-flex _flex-direction-column _text-center">
                  <span class="_font-weight-semibold _font-size-lg">{{row["object-id"]}}</span>
                  <img class="lazyload image" alt="Light curve real image"
                       v-bind:src="require('./../assets/raw_data/images/'+row['lc-file'])"/>
                </div>
              </template>
            </i-tooltip>
          </td>
          <td class="_align-middle _display-xs-table-cell _display-md-none _display-lg-none _display-xl-none">
            <a v-bind:href="require('./../assets/raw_data/images/'+row['lc-file'])" target="_blank">Image</a>
          </td>
        </tr>
        </tbody>
      </i-table>
      <i-pagination size="sm" id="pagination" v-model="currentPage" :items=totalItems :items-per-page="itemsPerPage"
                    @change="paginationChanged"></i-pagination>
    </i-container>
    <i-modal id="modal-phase" variant="secondary" v-model="visible[0]" size="lg" @hide="visible = [false, '']">
      <template slot="header">Details for object with COSPAR: {{visible[1]["object-id"]}}</template>
      <i-container class="_display-xs-none _display-sm-none">
        <i-row class="_text-center">
          <i-column xs="12" id="modal-phase-image-place" class="_margin-bottom-1">
            <!--injected image-->
          </i-column>
        </i-row>
        <i-row>
          <i-column xs="6" md="3">
            Object name:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["object-name"]}}
          </i-column>
          <i-column xs="6" md="3">
            Source
          </i-column>
          <i-column xs="6" md="3" id="source-column">

          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            COSPAR:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["object-id"]}}
          </i-column>
          <i-column xs="6" md="3">
            Period [sec]:
          </i-column>
          <i-column xs="6" md="3">
            <span v-if="visible[1]['period'] === '9999'">N/A (unavailable)</span>
            <span v-else-if="visible[1]['period'] === '6000'">N/A (stable)</span>
            <span v-else-if="visible[1]['period'] === '7000'">N/A (slow)</span>
            <span v-else>{{visible[1]["period"]}}</span>
          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            Object type:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["object-type"]}}
          </i-column>
          <i-column xs="6" md="3">
            Period error [sec]:
          </i-column>
          <i-column xs="6" md="3">
            <span v-if="visible[1]['perr']">{{visible[1]["perr"]}}</span>
            <span v-else>N/A</span>
          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            NORAD:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["norad"]}}
          </i-column>
          <i-column xs="6" md="3">
            Amplitude [mag]:
          </i-column>
          <i-column xs="6" md="3">
            <span v-if="visible[1]['ampdat']">{{visible[1]["ampdat"]}}</span>
            <span v-else>N/A</span>
          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            Orbital period:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["orbital-period"]}}
          </i-column>
          <i-column xs="6" md="3">
            Amp. error [mag]:
          </i-column>
          <i-column xs="6" md="3">
            <span v-if="visible[1]['amperr']">{{visible[1]["amperr"]}}</span>
            <span v-else>N/A</span>
          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            Inclination [deg]:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["inclination"]}}
          </i-column>
          <i-column xs="6" md="3">
            Number of points:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["points"]}}
          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            Perigee [km]:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["perigee"]}}
          </i-column>
          <i-column xs="6" md="3">
            Exposure [sec]:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["exposure"]}}
          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            Apogee [km]:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["apogee"]}}
          </i-column>
          <i-column xs="6" md="3">
            Mean samp. [sec]:
          </i-column>
          <i-column xs="6" md="3">
            <span v-if="visible[1]['apd']">{{visible[1]["apd"]}}</span>
            <span v-else>N/A</span>
          </i-column>
        </i-row>

        <i-row>
          <i-column xs="6" md="3">
            Decayed:
          </i-column>
          <i-column xs="6" md="3">
            {{visible[1]["decayed"]}}
          </i-column>
          <i-column xs="6" md="3">
            Filter:
          </i-column>
          <i-column xs="6" md="3">
            <span v-if="visible[1]['filter'] !== undefined">{{visible[1]['filter']}}</span>
            <span v-else>N/A</span>
          </i-column>
        </i-row>
      </i-container>
      <i-container class="_display-xs-block _display-sm-block _display-md-none _display-lg-none _display-xl-none">
        <i-row>
          <i-column xs="12" id="modal-phase-image-place-res" class="_margin-bottom-1">
            <!--injected image-->
          </i-column>
          <i-column xs="6">
            Object name:
          </i-column>
          <i-column xs="6" class="_align-bottom">
            {{visible[1]["object-name"]}}
          </i-column>
          <i-column xs="6">
            COSPAR:
          </i-column>
          <i-column xs="6">
            {{visible[1]["object-id"]}}
          </i-column>
          <i-column xs="6">
            Object type:
          </i-column>
          <i-column xs="6">
            {{visible[1]["object-type"]}}
          </i-column>
          <i-column xs="6">
            NORAD:
          </i-column>
          <i-column xs="6">
            {{visible[1]["norad"]}}
          </i-column>
          <i-column xs="6">
            Orbital period:
          </i-column>
          <i-column xs="6">
            {{visible[1]["orbital-period"]}}
          </i-column>
          <i-column xs="6">
            Inclination [deg]:
          </i-column>
          <i-column xs="6">
            {{visible[1]["inclination"]}}
          </i-column>
          <i-column xs="6">
            Perigee [km]:
          </i-column>
          <i-column xs="6">
            {{visible[1]["perigee"]}}
          </i-column>
          <i-column xs="6">
            Apogee [km]:
          </i-column>
          <i-column xs="6">
            {{visible[1]["apogee"]}}
          </i-column>
          <i-column xs="6">
            Decayed:
          </i-column>
          <i-column xs="6" class="_margin-bottom-xs-1-2 _margin-bottom-sm-1-2">
            {{visible[1]["decayed"]}}
          </i-column>

          <i-column xs="6">
            Source
          </i-column>
          <i-column xs="6" id="source-column">
          </i-column>
          <i-column xs="6">
            Period [sec]:
          </i-column>
          <i-column xs="6">
            <span v-if="visible[1]['period'] === '9999'">N/A (unavailable)</span>
            <span v-else-if="visible[1]['period'] === '6000'">N/A (stable)</span>
            <span v-else-if="visible[1]['period'] === '7000'">N/A (slow)</span>
            <span v-else>{{visible[1]["period"]}}</span>
          </i-column>
          <i-column xs="6">
            Period error [sec]:
          </i-column>
          <i-column xs="6" class="_display-flex _align-items-center">
            <span v-if="visible[1]['perr']">{{visible[1]["perr"]}}</span>
            <span v-else>N/A</span>
          </i-column>
          <i-column xs="6">
            Amplitude [mag]:
          </i-column>
          <i-column xs="6" class="_display-flex _align-items-center">
            <span v-if="visible[1]['ampdat']">{{visible[1]["ampdat"]}}</span>
            <span v-else>N/A</span>
          </i-column>
          <i-column xs="6">
            Amp. error [mag]:
          </i-column>
          <i-column xs="6" class="_display-flex _align-items-center">
            <span v-if="visible[1]['amperr']">{{visible[1]["amperr"]}}</span>
            <span v-else>N/A</span>
          </i-column>
          <i-column xs="6">
            Number of points:
          </i-column>
          <i-column xs="6" class="_display-flex _align-items-center">
            {{visible[1]["points"]}}
          </i-column>
          <i-column xs="6">
            Exposure [sec]:
          </i-column>
          <i-column xs="6" class="_display-flex _align-items-center">
            {{visible[1]["exposure"]}}
          </i-column>
          <i-column xs="6">
            Mean samp. [sec]:
          </i-column>
          <i-column xs="6" class="_display-flex _align-items-center">
            <span v-if="visible[1]['apd']">{{visible[1]["apd"]}}</span>
            <span v-else>N/A</span>
          </i-column>
          <i-column xs="6">
            Filter:
          </i-column>
          <i-column xs="6">
            <span v-if="visible[1]['filter'] !== undefined">{{visible[1]['filter']}}</span>
            <span v-else>N/A</span>
          </i-column>
        </i-row>
      </i-container>
    </i-modal>
  </div>
</template>

<script>
  //TODO - treba vymenit period-error za perr
  export default {
    name: "LCDContent",
    data() {
      return {
        currentPage: 1,
        itemsPerPage: 20,
        database: undefined,
        databaseSlice: undefined,
        visible: [false, ""]
      }
    },
    props: {
      totalItems: {
        type: Number
      },
      filteredDatabase: {}
    },
    methods: {
      paginationChanged(item) {
        this.sliceTheDB();
      },
      sliceTheDB() {
        let filteredJson = {};

        this.database = this.filteredDatabase;

        let counter = 1;
        let lowerLimit = this.currentPage * this.itemsPerPage - this.itemsPerPage;
        let higherLimit = this.currentPage * this.itemsPerPage;

        for (let i in this.database) {
          let obj = this.database[i];
          if (counter > lowerLimit && counter <= higherLimit) {
            filteredJson[counter] = obj;
          }
          counter++;
        }
        // console.log(Object.keys(filteredJson).length)
        this.databaseSlice = filteredJson;
      },
      showModal(row) {
        this.visible = [true, row];

        let modalCol = document.getElementById("modal-phase-image-place");
        let modalColRes = document.getElementById("modal-phase-image-place-res");
        if (row['fit-file'] !== undefined) {
          let path = require('./../assets/raw_data/images/' + row['fit-file']);
          modalCol.innerHTML = "<img class='image -responsive _max-width-100' src='" + path + "' alt='Phase file'/>";
          modalColRes.innerHTML = "<img class='image -responsive _max-width-100' src='" + path + "' alt='Phase file'/>";
        } else {
          modalCol.innerHTML = "<p class='_text-warning'>No phase curve could be generated!</p>";
          modalColRes.innerHTML = "<p class='_text-warning'>No phase curve could be generated!</p>";
        }

        let sourceCol = document.getElementById("source-column");
        let lcFilePath = '/static/data/' + row['data-file'];

        sourceCol.innerHTML = "<a href='" + lcFilePath + "' class='_margin-right-1-2' target='_blank'>LC</a>"
      }
    },
    created: function () {
    },
    mounted: function () {
      this.database = this.filteredDatabase;
      this.sliceTheDB();
    },
    watch: {
      filteredDatabase: function (newVal, oldVal) {
        this.sliceTheDB();
      }
    }
  }
</script>

<style scoped>
  .pagination >>> .item, .pagination >>> .item.-disabled:hover {
    background-color: transparent;
    border-color: #1684a9;
    color: #1684a9;
  }

  .pagination >>> .item:hover {
    background-color: #1684a9;
    color: white;
  }

  .pagination >>> .item.-active {
    background-color: #1684a9 !important;
    color: white;
  }

  .pagination >>> .item.-previous {
    margin-left: 0 !important;
  }

  ._height-10 {
    height: 10% !important;;
  }

  ._width-10 {
    width: 10% !important;
  }

  ._width-15 {
    width: 15% !important;
  }

  img:hover {
    cursor: pointer;
  }

  .modal >>> .body {
    border-bottom-left-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  #modal-phase-image-place >>> img {
    max-height: 50vh;
    max-width: 50vw;
  }

  .dotted-underline {
    text-decoration-line: underline;
    text-decoration-style: dotted;
  }

  .row >>> .column:nth-child(odd) {
    font-weight: 700;
  }

  #modal-phase >>> .body {
    overflow-y: auto;
    max-height: 50vh;
    border-bottom-left-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  #modal-phase >>> .body {
    max-height: calc(var(--vh, 1vh) * 50);
  }

</style>



// WEBPACK FOOTER //
// src/components/Content.vue